import TextAreaField from '../Forms/Input/TextAreaField';
import { BusinessConfigurationForm } from '../../types/business/BusinessTypes';

interface Props {
  form: BusinessConfigurationForm;
  errors: Record<string, string>;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextSections = ({ form, errors, onChange }: Props) => (
  <div className="p-0">
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
        Personalización de Tiquetes
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Agregue textos personalizados que aparecerán en el encabezado y pie de los tiquetes.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <TextAreaField
        label="Texto de Encabezado"
        name="headerText"
        iconKey='edit'
        value={form.headerText}
        onChange={onChange}
        error={errors.headerText}
      />
      <TextAreaField
        label="Texto de Pie de Página"
        name="footerText"
        iconKey='edit'
        value={form.footerText}
        onChange={onChange}
        error={errors.footerText}
      />
    </div>
  </div>
);

export default TextSections;
